<template>
    <div class="div-discount">
        <Alert type="info">
            <span>
                Não será aplicado desconto em produto <b>Faturado</b>!
            </span>
        </Alert>
        <div class="sd-wrap">
            <div class="sd-mode">
                <button type="button" class="sd-chip" :class="{ active: mode === 'money' }"
                    @click="mode = 'money'">R$</button>
                <button type="button" class="sd-chip" :class="{ active: mode === 'percent' }" @click="mode = 'percent'">
                    <span>
                        <i class="fa-solid fa-percent"></i>
                    </span>
                </button>
            </div>

            <InputSmartValue v-model="discountValue" :mode="mode" @enter="tryApply" />
        </div>

        <div class="div-apply text-center">
            <Button _key="btnApplyDiscount" title="Aplicar" color="white" backGroundColor="#EF4444" size="medium"
                :clicked="update" :disabled="isSubmitting || !isValid" />
        </div>
    </div>
</template>

<script>
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import InputSmartValue from "./InputSmartValue.vue";

import { mapActions, mapMutations } from "vuex";

export default {
    name: "ApplyDiscount",
    props: ["rentId", "item", "selected"],
    components: { Alert, Button, InputSmartValue },
    data() {
        return {
            urlUpdate: "/api/v1/rental/items-rent/apply-discount",
            mode: "money",
            discountValue: 0,
            isSubmitting: false
        };
    },
    computed: {
        isValid() {
            if (this.mode === "percent") return this.discountValue >= 0 && this.discountValue <= 100;
            return this.discountValue >= 0;
        }
    },
    methods: {
        ...mapActions("generic", ["putApi"]),
        ...mapMutations("generic", ["addSelected", "addEvent", "removeLoading", "hideModal"]),
        tryApply() {
            if (this.isValid && !this.isSubmitting) this.update();
        },
        update() {
            const payload = {
                url: this.urlUpdate,
                obj: {
                    listIds: this.selected.length > 0 ? this.selected : [this.item.id],
                    rentId: this.rentId,
                    discountByPercentage: this.mode === "percent",
                    unitDiscount: this.discountValue
                }
            };

            this.isSubmitting = true;
            this.putApi(payload)
                .then((r) => {
                    if (r?.success) {
                        this.addEvent({ name: "updateTotalizationRent" });
                        this.hideModal();
                    }
                    this.addSelected([]);
                    this.removeLoading(["btnApplyDiscount"]);
                    this.isSubmitting = false;
                })
                .catch(() => {
                    this.removeLoading(["btnApplyDiscount"]);
                    this.isSubmitting = false;
                });
        }
    }
};
</script>

<style scoped>
.div-apply {
    margin-top: 15px;
}

.div-discount {
    display: grid;
    gap: 10px;
}

.sd-wrap {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px;
    align-items: center;
}

.sd-mode {
    display: inline-flex;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    overflow: hidden;
}

.sd-chip {
    padding: 6px 12px;
    border: none;
    background: #fff;
    cursor: pointer;
    font-weight: 700;
}

.sd-chip+.sd-chip {
    border-left: 1px solid #e5e7eb;
}

.sd-chip.active {
    background: #ef4444;
    color: #fff;
}
</style>
